import React from 'react'

const NavigationButton = ({
  onClick,
  children,
  className = "",
  ...props
}) => {
  return (
    <button
      onClick={onClick}
      className={className}
      {...props}
    >
      {children}
    </button>
  );
};

export default NavigationButton;